module.exports = __webpack_public_path__ + "media/images/badge/abbonato-349f4108634d5690dff2b1175ef7d21a.png";